<template>
  <div>
    <b-row>

      <b-col md="12" class="d-flex align-items-center justify-content-between mb-1">
        <span class="text-muted" style="font-size:0.78rem;">Los campos con * son obligatorios</span>
        <b-link v-if="item && viewEdit"
                href="javascript:void(0);"
                class="small"
                @click="openFullEdit()">
          <b-icon icon="box-arrow-up-right" class="mr-1"></b-icon>
          Ver ficha completa
        </b-link>
      </b-col>

      <b-col md="12">
        <b-form-group label="Razón Social *" label-size="sm">
          <b-form-input v-model="form.name"
                        size="sm"
                        placeholder="Nombre o razón social"
                        ref="inputName"
                        :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="5">
        <b-form-group label="Condición Fiscal" label-size="sm">
          <b-form-select v-model="form.fiscal_conditions_id"
                         :options="options.fiscalConditions"
                         size="sm"
                         :disabled="loading">
            <template #first>
              <b-form-select-option :value="0">— Seleccionar —</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Tipo Documento" label-size="sm">
          <b-form-select v-model="form.types_documents_id"
                         :options="options.typesDocuments"
                         size="sm"
                         :disabled="loading">
            <template #first>
              <b-form-select-option :value="0">— Tipo —</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Número" label-size="sm">
          <b-form-input v-model="form.documents_number"
                        size="sm"
                        placeholder="Ej: 20-12345678-9"
                        :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group label="Dirección" label-size="sm">
          <b-form-input v-model="form.address"
                        size="sm"
                        placeholder="Calle, número, piso..."
                        :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="5">
        <b-form-group label="Ciudad" label-size="sm">
          <b-form-input v-model="form.city" size="sm" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Provincia" label-size="sm">
          <b-form-input v-model="form.state" size="sm" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="País" label-size="sm">
          <b-form-input v-model="form.country" size="sm" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="12" class="d-flex justify-content-end mt-1">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$emit('cancel')" :disabled="loading">
          Cancelar
        </b-button>
        <b-button variant="primary" size="sm" @click="save()" :disabled="loading || !form.name.trim()">
          <b-icon icon="check" class="mr-1"></b-icon>
          Guardar
        </b-button>
      </b-col>

    </b-row>
  </div>
</template>
<script>
  import serviceAPI from '../services'
  import Funciones from '@/handler/funciones'

  const emptyForm = () => ({
    name: '',
    fiscal_conditions_id: 0,
    types_documents_id: 0,
    documents_number: '',
    address: '',
    city: '',
    postal_code: '',
    state: '',
    country: '',
    credit_limit: 0.00,
    methods_payment_id: 0,
    points_sales_id: 0,
    shipping_id: 0,
    methods_acopio_id: 0,
    block_positive_balance: false,
    observations: '',
  })

  export default {
    props: {
      item: { type: Object, default: null },
      viewEdit: { type: String, default: '' },
      viewEditParamID: { type: String, default: '' },
      viewEditParamId: { type: String, default: '' },
    },
    data() {
      return {
        form: emptyForm(),
        customer: null,
        fiscal: null,
        loading: false,
        options: {
          fiscalConditions: [],
          typesDocuments: [],
        },
      }
    },
    watch: {
      item: {
        immediate: true,
        handler(val) {
          if (val) {
            this.loadForEdit(val.id)
          } else {
            this.form = emptyForm()
            this.customer = null
            this.fiscal = null
          }
        },
      },
    },
    mounted() {
      this.loadOptions()
      this.$nextTick(() => { if (this.$refs.inputName) this.$refs.inputName.focus() })
    },
    methods: {
      loadOptions() {
        serviceAPI.obtenerFiscalConditions().then((r) => {
          this.options.fiscalConditions = r.data.map((x) => ({ value: x.id, text: x.name }))
        })
        serviceAPI.obtenerTypesDocuments().then((r) => {
          this.options.typesDocuments = r.data.map((x) => ({ value: x.id, text: x.name }))
        })
      },
      loadForEdit(id) {
        this.loading = true
        serviceAPI.obtenerCliente(id)
          .then((r) => {
            var c = r.data
            this.customer = Object.assign({}, c)
            this.form = Object.assign(emptyForm(), c.data_fiscal || {})
            this.form.name = c.name || ''
            if (c.data_fiscal) {
              this.fiscal = Object.assign({}, c.data_fiscal)
              this.form.fiscal_conditions_id = this.form.fiscal_conditions_id || 0
              this.form.types_documents_id   = this.form.types_documents_id   || 0
              this.form.documents_number     = this.form.documents_number      || ''
              this.form.address              = this.form.address               || ''
              this.form.city                 = this.form.city                  || ''
              this.form.state                = this.form.state                 || ''
              this.form.country              = this.form.country               || ''
            }
          })
          .finally(() => { this.loading = false })
      },
      validateCuit() {
        if (!this.form.documents_number) return true
        var selectedType = this.options.typesDocuments.find((t) => t.value === this.form.types_documents_id)
        if (selectedType && selectedType.text === 'CUIT') {
          if (!Funciones.validarCUIT(this.form.documents_number)) {
            this.$awn.alert('El CUIT es inválido')
            return false
          }
        }
        return true
      },
      openFullEdit() {
        var paramName = this.viewEditParamID || this.viewEditParamId
        if (!this.item || !this.item.id || !this.viewEdit || !paramName) return

        var params = {}
        params[paramName] = this.item.id
        var route = this.$router.resolve({ name: this.viewEdit, params: params })
        window.open(route.href, '_blank')
      },
      save() {
        if (!this.form.name.trim()) return
        if (!this.validateCuit()) return

        this.loading = true
        var isEdit = this.item && this.item.id
        var customerData = isEdit
          ? Object.assign({}, this.customer || {}, { id: this.item.id, name: this.form.name })
          : { name: this.form.name, active: true }
        delete customerData.data_fiscal

        var customerCall = isEdit
          ? serviceAPI.editarCliente(customerData)
          : serviceAPI.agregarCliente(customerData)

        customerCall
          .then((r) => {
            var customer = r.data
            var fiscalData = Object.assign({}, this.fiscal || {}, {
              customers_id:           customer.id,
              business_name:          this.form.name,
              fiscal_conditions_id:   this.form.fiscal_conditions_id || null,
              types_documents_id:     this.form.types_documents_id   || null,
              documents_number:       (this.form.documents_number || '').replace(/\D/g, ''),
              address:                this.form.address,
              city:                   this.form.city,
              postal_code:            this.form.postal_code,
              state:                  this.form.state,
              country:                this.form.country,
              credit_limit:           this.form.credit_limit,
              methods_payment_id:     this.form.methods_payment_id,
              points_sales_id:        this.form.points_sales_id,
              shipping_id:            this.form.shipping_id,
              methods_acopio_id:      this.form.methods_acopio_id,
              block_positive_balance: this.form.block_positive_balance,
              observations:           this.form.observations,
            })

            var fiscalCall = (isEdit && this.fiscal)
              ? serviceAPI.editarSalesCustomers({ ...fiscalData, id: this.fiscal.id })
              : serviceAPI.agregarSalesCustomers(fiscalData)

            return fiscalCall.then(() => customer)
          })
          .then((customer) => {
            this.$awn.success(isEdit ? 'Cliente actualizado' : 'Cliente creado')
            this.$emit('saved', customer)
          })
          .catch(() => { this.$awn.alert('Error al guardar el cliente') })
          .finally(() => { this.loading = false })
      },
    },
  }
</script>
